function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.22,43.77s-73.45-21.63-146,22.12S73.73,191.21,42,256.67,27.85,386.24,82.82,413.17s92.77-18.6,170.17-24.54,98.14,3.72,162.63-41.6,76.76-145.46,26.59-216.64S329.22,43.77,329.22,43.77Z",
    style: {
      fill: "#999999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.22,43.77s-73.45-21.63-146,22.12S73.73,191.21,42,256.67,27.85,386.24,82.82,413.17s92.77-18.6,170.17-24.54,98.14,3.72,162.63-41.6,76.76-145.46,26.59-216.64S329.22,43.77,329.22,43.77Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.93,424.65s-24.77-52.76-19.39-54.28,16.66,6.88,16.66,6.88-33.1-88.7-24.53-95.58S69.24,310,69.24,310,52.15,255.67,54.16,235s23.72-.76,23.72-.76-17.39-74.17-1.24-78,15.61,84.87,15.61,84.87,5.3-63.47,11.77-45.88-7.13,76.46-7.13,76.46,8.87-19.88,13.8-1.53-9.8,92.52-9.8,92.52,12.52-12.23,13.69,3.06-25.92,62.7-25.92,62.7L73.33,430Z",
    style: {
      fill: "#999999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.93,424.65s-24.77-52.76-19.39-54.28,16.66,6.88,16.66,6.88-33.1-88.7-24.53-95.58S69.24,310,69.24,310,52.15,255.67,54.16,235s23.72-.76,23.72-.76-17.39-74.17-1.24-78,15.61,84.87,15.61,84.87,5.3-63.47,11.77-45.88-7.13,76.46-7.13,76.46,8.87-19.88,13.8-1.53-9.8,92.52-9.8,92.52,12.52-12.23,13.69,3.06-25.92,62.7-25.92,62.7L73.33,430Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.21,427s-20.64-36.7-16.82-43.59,15.29,9.18,15.29,9.18-26-65-22.17-71.11,16.06,20.65,16.06,20.65S65,252.62,72.62,255.67,81,301.55,81,301.55s-4.58-101.69,2.3-98.63,6.12,116.22,6.12,116.22,13.76-43.59,16-23.71-17.58,73.41-17.58,73.41S107,326.78,109.33,349,94,412.42,94,412.42s6.88-16.82,6.88-7.65-5.35,20.65-5.35,20.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Calendar--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "51.43 383.46 38.26 426.86 73.93 426.86 87.5 383.69 51.43 383.46",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.6 426.79 60.27 426.79 51.43 383.46 125.76 383.46 134.6 426.79",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.94 419.46 64.94 419.46 60.31 396.79 122.31 396.79 126.94 419.46",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.64,
    y1: 396.88,
    x2: 70.23,
    y2: 419.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.33,
    y1: 396.88,
    x2: 75.92,
    y2: 419.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.02,
    y1: 396.88,
    x2: 81.61,
    y2: 419.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.7,
    y1: 396.88,
    x2: 87.29,
    y2: 419.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.39,
    y1: 396.88,
    x2: 92.98,
    y2: 419.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.08,
    y1: 396.88,
    x2: 98.67,
    y2: 419.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99.76,
    y1: 396.88,
    x2: 104.35,
    y2: 419.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105.45,
    y1: 396.88,
    x2: 110.04,
    y2: 419.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111.13,
    y1: 396.88,
    x2: 115.72,
    y2: 419.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.82,
    y1: 396.88,
    x2: 121.41,
    y2: 419.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.37,
    y1: 401.27,
    x2: 123.02,
    y2: 401.27,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62.29,
    y1: 405.79,
    x2: 123.94,
    y2: 405.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.22,
    y1: 410.32,
    x2: 124.86,
    y2: 410.32,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64.14,
    y1: 414.84,
    x2: 125.79,
    y2: 414.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.32 392.87 59.79 392.87 59.35 390.67 86.87 390.67 87.32 392.87",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463,316H373.34a17.69,17.69,0,0,0-17.12,15.38l-11,97.23h105Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.47,316h0a14.69,14.69,0,0,0-14.22,12.78l-11.31,99.83h25.54l11.32-99.83A11.18,11.18,0,0,0,463.47,316Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.29,286.79A98.34,98.34,0,0,1,324,297.93c-12.73,5.3-17.85,6.9-17.85,6.9l3.53,121.8H402.1s-11.85-76.37-11.85-102S391.31,294,391.31,294l-30.4-7.78Z",
    style: {
      fill: "#999999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.21,291.92a554,554,0,0,0-5.12,62.4c-.53,31.29,5.48,73,5.48,73H266.86a183,183,0,0,0,17.87-50.7c5-25.33,9-68.27,10.06-68.8S331.74,294,334.21,291.92Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.46,427.33s-6.9-46.67-6.55-57.63S299,321.62,299,321.62",
    style: {
      fill: "none",
      stroke: "#616161",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.22,288.74s-8.66,39.77-9.37,72.48-3,66.29-3,66.29h54.75s.71-29.88,0-40.13-.71-8.13-.71-8.13l21.22,5.48s-13.62-65.59-16.09-72.83-1.24-9.55-2.83-10.79S372.22,288.74,372.22,288.74Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.33,400.29a33.53,33.53,0,0,0,5,6c2.43,2.08,7.64,1,10.41,3.84s-.26,11.51-3.76,14.54c-6,5.17-2.82-10.52-2.82-10.52a23.73,23.73,0,0,1-6.92,3.25c-3.4.78-12.15-1.88-15.08-2s-7-.68-8.56-3.94,8.12-7.19,12.42-8.75A63,63,0,0,1,273.33,400.29Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.81,404.89a4.9,4.9,0,0,0-5.11,1.7c-2,2.63-6,14.51-4.83,16.8s4.2-.92,5.64-4.69a25.31,25.31,0,0,1,2.44-5.19s1.58.77,2.69-1.29S257.87,407.07,254.81,404.89Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.47,402.82a4.84,4.84,0,0,0-6.05,1c-2.81,3-.88,15.61.61,19.47s4.31,3.38,4.73,1,.9-14.25,1.05-17A14.2,14.2,0,0,0,260.47,402.82Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.47,401.46a4.62,4.62,0,0,0-6.05,1c-2.79,3.17-.73,16.51.8,20.61s4.35,3.62,4.75,1.07.76-15.08.88-18A16.14,16.14,0,0,0,266.47,401.46Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.25,403.08s-2.33-5.21-6.13-4.35-5,6-4.3,13.8,2.16,14,4.28,14.22,4.43-4.49,4.85-10.58,1.05-9.73,1.05-9.73",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.54,
    y: 348.57,
    width: 23.57,
    height: 36.18,
    style: {
      fill: "#999999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.63,
    y: 338.03,
    width: 4.34,
    height: 16.74,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.32,
    y: 358.7,
    width: 10.13,
    height: 13.23,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 304.67,
    y1: 375.86,
    x2: 318.52,
    y2: 375.86,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 302.6,
    y1: 378.75,
    x2: 320.38,
    y2: 378.75,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.82,281.67s-7.61,5.12-9,9.19-7.25,21.39-9.55,27.93-15.38,12.2-13.61,13.44,18.92,2.82,18.92,2.82,3.89,15.21,4.77,19.1,6.19,15.73,6.19,15.73,15.73-18.92,18.21-24a80.08,80.08,0,0,1,5.83-9.9s6.72,1.59,11,2.3,15.91,1.76,15.38-.18-6.36-10.43-8.66-18.74-.89-26.52-3.71-33.59-9-8.13-11.14-8.66S345,278.66,341.82,281.67Z",
    style: {
      fill: "#999999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.34,276.19s2.3,12.9,2,23.33-4.07,33.77-3.89,45.79a204.07,204.07,0,0,0,1.94,23.86s17.33-23.86,23.69-43.31,8.13-36.06,8.13-37.3.35-30.05.35-30.05S353.13,277.78,339.34,276.19Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.37,270.74c.07-6.48.14-12.23.14-12.23s-18.38,19.27-32.17,17.68c0,0,.65,3.63,1.2,8.6a19.09,19.09,0,0,0,5.92,2.71c6.38,1.28,13.53-2.29,18.38-8.42C366.63,276.82,369,273.74,371.37,270.74Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 383.98,
    cy: 194.78,
    rx: 17.59,
    ry: 17.41,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.75,225.2s-9.44-2.56-11-7.66,4.09-23,22.47-32.17,35.24-4.09,42.64-2.05,12.77,5.88,17.62,19.41,5.1,24,3.57,29.1a72.63,72.63,0,0,1-3.32,8.94s-9.44,1-12-2.81-1.53-23-12.51-27.57-31.91-2-37,2.55S312.75,225.2,312.75,225.2Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.22,221.88s2.3,14.55,2.3,22.46,6.38,18.9,9.7,22,14.3,13.53,20.68,14.81,13.53-2.3,18.38-8.43,14.3-18.38,14.3-18.38a9.09,9.09,0,0,0,9.7-6.38c2.56-7.41,1.28-15.83-3.06-16.85s-7.4,4.08-7.4,4.08-3.58-13.78-8.17-20.68l-6.64-10,8.47-10.59a1.08,1.08,0,0,0-.22-1.56h0a1.09,1.09,0,0,0-1.49.21l-8.29,10.67s-16.34-2.81-30.64,4.34S311.22,221.88,311.22,221.88Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 363.68,
    y1: 236.25,
    x2: 361.38,
    y2: 239.32,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.16,253.79s.51,1.53,3.83,2.3a8.21,8.21,0,0,0,8.42-3.06",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336,262a18.61,18.61,0,0,0,17.61-5.36s-2.29,9.7-6.89,11.49-4.85-3.07-4.85-3.07Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.18,242.56a17.64,17.64,0,0,1,16.08-4.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.58,242.05s-5.61-5.62-11.49-2.56",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 315.31,
    y1: 238.22,
    x2: 318.11,
    y2: 241.03,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.39,228.77S351,220,362,228.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.07,228.51s-6.89-5.36-13.79.77",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.19,241.19A1.24,1.24,0,1,1,350,240,1.24,1.24,0,0,1,351.19,241.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,240.12a1.24,1.24,0,1,1-1.24-1.23A1.24,1.24,0,0,1,322,240.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.33,215.22s.88,11.49-1.24,20.15l3.36,1.06s2.65-13.26,1.41-20.68Z",
    style: {
      fill: "#999999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.49,181.61a31.26,31.26,0,0,1,15.74,18.21c4.06,13.08,3.53,17.15,6,18.56s7.25,2.3,7.42-.88-.93-17.37-8-26.17C375.35,184.63,363.91,181.79,359.49,181.61Z",
    style: {
      fill: "#999999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.73,232.84c-5.09-1.56-10.68,2-12.5,7.91-1.68,5.47.46,11.05,4.8,13.11a66.74,66.74,0,0,1-13.95,21.77,4.73,4.73,0,0,0-3.32.84c-1.82,1.23-2.62,3.24-1.77,4.5s3,1.28,4.83.06,2.48-3,1.9-4.22a67.74,67.74,0,0,0,14.22-22.31c4.86,1,10-2.48,11.71-8.11C391.47,240.47,388.82,234.4,383.73,232.84Z",
    style: {
      fill: "#999999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.05,244.4c-.86,3.78-4.27,6.24-7.62,5.48s-5.37-4.45-4.51-8.23,4.27-6.24,7.62-5.49S388.91,240.61,388.05,244.4Z",
    style: {
      fill: "#999999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.07,306.77s-4.95-12.37-6-14.67,7.6-15.91,9-17.86,4.06-6,4.06-6.89-10.07-10.79-12.2-12.38-5.65,2-5.65,2-9.19,12.2-9.19,13.61,4.41,5.83,4.41,5.83-6.89,9.9-6,13.79,4.42,7.25,4.42,7.25l4.95,19.09Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.51,276.36s6-4.77,5.48-6.18a2.25,2.25,0,0,0-2.29-1.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.76,258.51c.53,0,16.08,10.25,15.73,12a15.51,15.51,0,0,1-1.41,3.71",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.53,256.92s14.67,9.19,15,10.78a3.25,3.25,0,0,1-1.06,2.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.12,255.33s15.38,10.43,15,12a10.89,10.89,0,0,1-1.94,3.53",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.19,305.36,365.5,319s30.76,73.18,36.42,83.08,20.86,12.2,28.82,9.55,11.84-18.56,9.19-25.28S418.18,350.26,409,335.58,389.19,305.36,389.19,305.36Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.67,344s26,50,32.66,60",
    style: {
      fill: "none",
      stroke: "#616161",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 391.33,
    y1: 311.29,
    x2: 428,
    y2: 367.29,
    style: {
      fill: "none",
      stroke: "#616161",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--text-balloon--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.35,238.86V206.67a4.68,4.68,0,0,0-4.68-4.68H204.16a4.68,4.68,0,0,0-4.68,4.68v32.19a4.68,4.68,0,0,0,4.68,4.68h67.42l15.35,14.77-3.07-14.94A4.68,4.68,0,0,0,287.35,238.86Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 227.91,
    cy: 222.13,
    r: 3.51,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 243.41,
    cy: 222.13,
    r: 3.51,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.92,
    cy: 222.13,
    r: 3.51,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.23,238.12v-7.2l-7.57-1.68a19.64,19.64,0,0,0-1.73-4.2l4.15-6.54L202,213.41l-6.54,4.16a18.78,18.78,0,0,0-4.19-1.73l-1.69-7.57h-7.2l-1.68,7.57a18.66,18.66,0,0,0-4.2,1.73L170,213.41l-5.09,5.09L169,225a18.66,18.66,0,0,0-1.73,4.2l-7.57,1.68v7.2l7.57,1.69A18.78,18.78,0,0,0,169,244l-4.16,6.54,5.09,5.09,6.54-4.16a19.17,19.17,0,0,0,4.2,1.74l1.68,7.56h7.2l1.69-7.56a19.29,19.29,0,0,0,4.19-1.74l6.54,4.16,5.09-5.09L202.93,244a19.77,19.77,0,0,0,1.73-4.19ZM186,243.82a9.3,9.3,0,1,1,9.3-9.3A9.3,9.3,0,0,1,186,243.82Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.77,
    y: 420.56,
    width: 165.4,
    height: 6.67,
    transform: "translate(462.94 847.8) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.38,
    y: 420.56,
    width: 144.16,
    height: 6.67,
    transform: "translate(390.91 847.8) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.58 408.7 258.5 408.7 243.63 303.41 105.71 303.41 120.58 408.7",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.87 408.7 252.79 408.7 237.92 303.41 100 303.41 114.87 408.7",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.13,359.76l-13.84,67.48h35.59l13.84-67.48Zm24.14,20a1.25,1.25,0,0,1-1.23,1l-20.16-.2a1.26,1.26,0,0,1-1.21-1.55l1.82-7.57a1.25,1.25,0,0,1,1.23-1l20.17.19a1.26,1.26,0,0,1,1.2,1.55Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.25,
    y: 427.24,
    width: 465.5,
    height: 4.84,
    transform: "translate(504 859.32) rotate(180)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icons--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "352.86 107.53 349.92 99 320.39 99 323.06 149 391.72 149 391.72 107.53 352.86 107.53",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "391.72 149 397.58 103.19 351.08 103.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.45,
    cy: 124.42,
    r: 34.55,
    transform: "translate(1.9 251.24) rotate(-76.8)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.45,
    cy: 124.42,
    r: 27.84,
    transform: "translate(1.36 250.57) rotate(-76.55)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.14,124.42a3.69,3.69,0,1,1-3.69-3.69A3.69,3.69,0,0,1,163.14,124.42Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.34,
    y1: 98.67,
    x2: 159.34,
    y2: 105.56,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.34,
    y1: 143.42,
    x2: 159.34,
    y2: 150.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.09,
    y1: 106.23,
    x2: 145.95,
    y2: 111.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172.73,
    y1: 137.87,
    x2: 177.59,
    y2: 142.74,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.53,
    y1: 124.49,
    x2: 140.41,
    y2: 124.49,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 178.27,
    y1: 124.49,
    x2: 185.15,
    y2: 124.49,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.09,
    y1: 142.74,
    x2: 145.95,
    y2: 137.87,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172.73,
    y1: 111.1,
    x2: 177.59,
    y2: 106.23,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.76,
    y1: 124.42,
    x2: 145.57,
    y2: 124.42,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.45,
    y1: 120.73,
    x2: 159.45,
    y2: 107.28,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.75,
    y: 99,
    width: 79.33,
    height: 50.67,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "215.75 99 255.41 124.33 295.08 99",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215.75,
    y1: 149.67,
    x2: 245.75,
    y2: 122.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 294.7,
    y1: 149.67,
    x2: 264.7,
    y2: 122.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.70f53c7474ec74ff204c2bbe8b06e230.svg";
export { ForwardRef as ReactComponent };